var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-image-noimage kst-image-container ks-cursor-not-allowed ks-flex-center has-text-centered",class:_vm.theClass},[_c('div',{staticClass:"px-4"},[_vm._v(_vm._s(_vm.theNoText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }